import React, { useState, useEffect } from "react";
import { Form, Check } from "@rocketseat/unform";
import * as CONSTANTS from "../../../services/constants";
import * as Yup from "yup";
import api from "../../../services/api";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import EmployeeFields from "../../../components/EmployeeFields";
import moment from "moment";

function EmployeeForm(props) {
  const [state, setState] = useState({
    data: null,
    sectors: [],
    functions: [],
    states: [],
    msgSuccess: null,
    errors: null,
    loading: false
  });

  useEffect(() => {
    fetchEmployee();
    fetchSelects();
    return () => {
      setState({ ...state, msgSuccess: null, errors: null, loading: false });
    };
  }, [props]);

  const fetchEmployee = () => {
    if (props.employeeData !== null) {
      var formatedDate = moment.utc(props.employeeData.birthDate);

      let formatedEmployee = {
        name: props.employeeData.name,
        birthDate: formatedDate.format("DD/MM/YYYY"),
        SectorId: props.employeeData.SectorId,
        rg: props.employeeData.rg,
        cpf: props.employeeData.cpf,
        phone: props.employeeData.phone,
        email: props.employeeData.email,
        address: props.employeeData.address,
        number: props.employeeData.number,
        district: props.employeeData.district,
        city: props.employeeData.city,
        state: props.employeeData.state,
        country: props.employeeData.country,
        complement: props.employeeData.complement,
        FunctionId: props.employeeData.FunctionId,
        CompanyId: props.employeeData.CompanyId,
        functionDescription: props.employeeData.functionDescription,
        EmployeeStatusId:
          props.employeeData.EmployeeStatusId !==
          CONSTANTS.EmployeeStatus.Desativado
      };

      setState({ ...state, data: formatedEmployee });
    } else {
      setState({ ...state, data: {} });
    }
  };

  const fetchSelects = async () => {
    const { sectors, functions } = props;

    if (sectors !== null && functions !== null) {
      setState({
        ...state,
        sectors: await props.sectors.map(item => {
          return { id: item.id, title: item.name };
        }),
        functions: await props.functions.map(item => {
          return { id: item.id, title: item.description };
        }),
        states: await CONSTANTS.states.map(item => {
          return { id: item.sigla, title: item.sigla };
        })
      });
    }
  };

  const transform = string => {
    var novo = string.replace(/[\-()._/]/g, "");
    return novo;
  };

  async function createEmployee(newdata, resetForm) {
    await api
      .post(`/employees`, newdata)
      .then(async result => {
        resetForm();
        await fetchSelects();
        setState({
          ...state,
          msgSuccess: result.data.msg,
          errors: null,
          loading: false,
          data: null
        });
        // Close modal after showing success message briefly
        setTimeout(() => {
          props.createEmployee();
        }, 1500);
      })
      .catch(({ response }) => {
        let errorMsg = "Oops.. Dados inválidos, por favor confira novamente!";
        
        if (response.statusText === "Unprocessable Entity") {
          errorMsg = "Oops.. Dados já cadastrados, por favor confira novamente!";
        }
        
        setState({
          ...state,
          errors: errorMsg,
          msgSuccess: null,
          loading: false,
        });
      });
  }

  const verifyNextStatus = checkBoxValue => {
    if (
      props.employeeData.EmployeeStatusId !==
        CONSTANTS.EmployeeStatus.Desativado &&
      checkBoxValue === true
    ) {
      return props.employeeData.EmployeeStatusId;
    } else if (
      props.employeeData.EmployeeStatusId ===
        CONSTANTS.EmployeeStatus.Desativado &&
      checkBoxValue === true
    ) {
      return CONSTANTS.EmployeeStatus.PendenteDeIntegração;
    } else if (
      props.employeeData.EmployeeStatusId !==
        CONSTANTS.EmployeeStatus.Desativado &&
      checkBoxValue === false
    ) {
      return CONSTANTS.EmployeeStatus.Desativado;
    }
  };

  const handleSubmit = async (data, { resetForm }) => {
    setState({ ...state, loading: true });
    //TODO: Verificar como usar o Datefns para formatar a data
    let birthDate = data.birthDate ? data.birthDate.split("/") : null;
    birthDate = birthDate
      ? birthDate[2] + "-" + birthDate[1] + "-" + birthDate[0]
      : null;

    let newdata = {
      ...data,
      phone: transform(data.phone).replace(" ", ""),
      cpf: transform(data.cpf),
      rg: transform(data.rg),
      birthDate: birthDate,
      email: data.email === "" ? null : data.email
    };

    if (props.employeeData) {
      newdata = {
        ...newdata,
        id: props.employeeData.id,
        EmployeeStatusId: verifyNextStatus(data.EmployeeStatusId)
      };


      console.log('orig data'); 

      console.log(newdata);

      console.log("TCL: handleSubmit -> newdata", newdata);
      props
        .updateEmployee(newdata)
        .then(result => {
          setState({
            ...state,
            msgSuccess: "Salvo com sucesso",
            errors: null,
            loading: false
          });
        })
        .catch(err => {
          console.log("TCL: handleSubmit -> err", err);
          setState({
            ...state,
            msgSuccess: null,
            errors:
              "Algo de errado aconteceu, verifique se os dados já existem",
            loading: false
          });
        });
    } else {
      console.log('newdata');

      console.log(newdata);

      if(typeof(newdata.CompanyId) === "undefined"){
        newdata.CompanyId = localStorage.getItem("CompanyId");
      }
      await createEmployee(newdata, resetForm);
    }
  };

  //TODO: Verificar a questão de edição do layout do schema.

  return (
    <>
      <Dialog
        open={props.open}
        fullWidth
        maxWidth="lg"
        onClose={props.handleOpenModal}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">
          {props.employeeData ? "Editar" : "Novo"} Colaborador
        </DialogTitle>

        <Form initialData={state.data} onSubmit={handleSubmit}>
          <DialogContent>
            <EmployeeFields
              functions={state.functions}
              sectors={state.sectors}
              states={state.states}
            />
          </DialogContent>

          <DialogActions>
            {state.msgSuccess && (
              <div className="alert alert-success">{state.msgSuccess}</div>
            )}
            {state.errors && (
              <div className="alert alert-danger alert-dismissible fade show">{state.errors}
                <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
            )}
            {props.employeeData && (
              <Check
                name="EmployeeStatusId"
                label={
                  props.employeeData.EmployeeStatusId !==
                  CONSTANTS.EmployeeStatus.Desativado
                    ? CONSTANTS.GeneralStatus.habilitado
                    : CONSTANTS.GeneralStatus.desativado
                }
              />
            )}
            <button
              onClick={props.handleOpenModal}
              type="reset"
              disabled={state.loading}
              className="btn btn-outline-danger"
            >
              {CONSTANTS.LabelButtons.sair}
            </button>
            {state.loading ? <i className="fa fa-spin fa-spinner"></i> : null}
            <button
              type="submit"
              disabled={state.loading}
              className="btn btn-success"
            >
              <i className="fa fa-check p-1" />
              {props.employeeData
                ? CONSTANTS.LabelButtons.salvar
                : CONSTANTS.LabelButtons.cadastrar}
            </button>
          </DialogActions>
        </Form>
      </Dialog>
    </>
  );
}

const schema = Yup.object().shape({
  name: Yup.string().required(),
  email: Yup.string().email()
});

export default EmployeeForm;
